import React from "react";
import Paper from "@mui/material/Paper";
import FormFader from "../Common/Fader/FormFader";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import FormSubmit from "../Common/FormSubmit/FormSubmit";
import { useForm } from "../../../provider/Form/FormProvider";
import Typography from "@mui/material/Typography";
import FormLegend from "../Common/FormLegend/FormLegend";
import FormSubmitProps from "../../../types/FormSubmitProps";
import wizardStyle from "../wizardStyle";
import OpposingPartyData from "../AbstractLitigationCase/OpposingPartyData";
import { AbstractCase } from "../../../types/Entities/AbstractCase";

type ContractPartnerProps = {
  product: AbstractCase;
  submitProps: FormSubmitProps;
};

export default function ContractPartner({ product, submitProps }: ContractPartnerProps) {
  const { values, handleSubmit } = useForm();

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }} onSubmit={handleSubmit}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            Ihr Vertrag
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline",
            }}
          >
            <Grid size={12}>
              <FormLegend>
                <strong>Angaben zum Vertragspartner / gegnerische Partei</strong>
              </FormLegend>
            </Grid>
            <Grid sx={[wizardStyle.gridTopSpaced, wizardStyle.question]} size={12}>
              <FormLegend>
                Damit wir rechtliche Schritte einleiten können, benötigen wir möglichst ausführliche Angaben zum Vertragspartner bzw. zu der gegnerischen
                Partei, gegen die Sie rechtlich vorgehen möchten.
              </FormLegend>
            </Grid>
            <OpposingPartyData product={product} />
          </Grid>
          <FormSubmit {...submitProps} />
        </Box>
      </FormFader>
    </Paper>
  );
}
